
import React, { PropsWithChildren } from 'react';

interface MotionProps {
  initial?: Record<string, unknown>;
  animate?: Record<string, unknown>;
  transition?: Record<string, unknown>;
  className?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const motion = {
  div: ({ 
    children, 
    initial, 
    animate, 
    transition, 
    className,
    onClick,
    onMouseEnter, 
    onMouseLeave
  }: PropsWithChildren<MotionProps>) => {
    return (
      <div 
        className={className} 
        style={{
          opacity: animate?.opacity !== undefined ? animate.opacity as number : 1,
          transform: `
            translateX(${animate?.x !== undefined ? `${animate.x}px` : '0px'})
            translateY(${animate?.y !== undefined ? `${animate.y}px` : '0px'})
            scale(${animate?.scale !== undefined ? animate.scale : 1})
          `,
          transition: transition ? 
            `all ${transition.duration || 0.3}s ease ${transition.delay || 0}s` 
            : 'all 0.3s ease'
        }}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </div>
    );
  },
  span: ({ 
    children, 
    initial, 
    animate, 
    transition, 
    className 
  }: PropsWithChildren<MotionProps>) => {
    return (
      <span 
        className={className} 
        style={{
          opacity: animate?.opacity !== undefined ? animate.opacity as number : 1,
          transform: `
            translateX(${animate?.x !== undefined ? `${animate.x}px` : '0px'})
            translateY(${animate?.y !== undefined ? `${animate.y}px` : '0px'})
            scale(${animate?.scale !== undefined ? animate.scale : 1})
          `,
          transition: transition ? 
            `all ${transition.duration || 0.3}s ease ${transition.delay || 0}s` 
            : 'all 0.3s ease'
        }}
      >
        {children}
      </span>
    );
  }
};
